<div class="review-stars">
  <div
    class="review-stars__block"
    *ngFor="let star of stars"
    (mouseenter)="setActiveValue(star)"
    (mouseleave)="reSetActiveValue()"
  >
    <div
      class="review-stars__star"
      [ngClass]="getClasses(star)"
      (click)="submitRating.emit(star + 1)"
      [style.width]="!!starSize.width ? starSize.width + 'px' : 'auto'"
      [style.height]="!!starSize.height ? starSize.height + 'px' : 'auto'"
    >
      <svg
        fill="none"
        viewBox="0 0 24 22"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
      >
        <path
          d="m10.8041.742195-2.72079 5.516665-6.0875.8875c-1.091664.15834-1.529164 1.50417-.7375 2.275l4.40417 4.29164-1.04167 6.0625c-.1875 1.0959.96667 1.9167 1.93334 1.4042l5.44585-2.8625 5.4458 2.8625c.9667.5083 2.1208-.3083 1.9333-1.4042l-1.0416-6.0625 4.4041-4.29164c.7917-.77083.3542-2.11666-.7375-2.275l-6.0875-.8875-2.7208-5.516665c-.4875-.983333-1.9-.995833-2.3917 0z"
          fill="#fff"
        />
      </svg>
    </div>
  </div>
</div>
